




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_PATH } from '../../../Constant/constants';
import useAuth from '../../../config/useAuth';
import { useParams } from 'react-router-dom';

const MedicineStock = () => {
  const [medicineData, setMedicineData] = useState(null);
  const [error, setError] = useState('');
  const { medicineId } = useParams();
  const { token } = useAuth();

  useEffect(() => {
    axios
      .get(`${API_PATH}/inventory/stock/${medicineId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setMedicineData(res.data))
      .catch((err) => {
        console.error('Error fetching medicine stock:', err);
        setError('Failed to fetch medicine stock. Check medicine ID or token.');
        setMedicineData(null);
      });
  }, [medicineId, token]);

  return (
    <div className="container my-4">
      <h4 className="mb-4">Get Medicine Stock</h4>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {medicineData && (
        <div className="card shadow-sm border-0">
          <div className="card-header bg-primary text-white">
            <h5 className="mb-0">Medicine Details</h5>
          </div>
          <div className="card-body">
            <p className="card-text">
              <strong>Medicine ID:</strong> {medicineData.medicineId}
            </p>
            <p className="card-text">
              <strong>Medicine Name:</strong> {medicineData.medicineName}
            </p>
            <p className="card-text">
              <strong>Current Stock:</strong>{' '}
              <span className="text-success fw-bold">
                {medicineData.currentStock}
              </span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MedicineStock;
